import { detachWrite, FirestoreWriteOp } from '@griply/services';
import {
  DocumentData,
  DocumentReference,
  serverTimestamp,
  setDoc,
  WithFieldValue,
} from 'firebase/firestore';
import { logFirestoreWriteError } from 'shared/services/error-tracking';

// Detached: a write promise never settles offline, and a rejection nobody handles reaches Sentry untagged.
export const setDocWithTimestamp = <Data extends DocumentData>(
  ref: DocumentReference,
  data: WithFieldValue<Data>,
  op: FirestoreWriteOp,
) =>
  detachWrite(setDoc(ref, { ...data, updatedAt: serverTimestamp() }), (error) =>
    logFirestoreWriteError({ op, error, docPath: ref.path }),
  );
